import React from 'react';
import { useSelector } from 'react-redux';

import { ImgWithFallback } from 'components';
import { appConfigSelector, appOptionsSelector } from 'reducers/app.reducer';
import defaultLogo from 'assets/default-logo.png';

const AppLogo = ({
  login = false,
  ...otherProps
}: {
  login?: boolean;
  [key: string]: unknown;
}): JSX.Element | null => {
  const { programUrl } = useSelector(appConfigSelector);
  const { list } = useSelector(appOptionsSelector);
  const WEBFILES_BASE = `${programUrl}/web_files/ui/img`;
  const appLogoUri = list.find(
    (item) => item.name === (login ? '$logoLogin' : '$logoHeader'),
  )?.value;

  if (!list?.length) {
    // it prevents from rendering a fallback image while waiting for the API response
    return null;
  }

  return (
    <ImgWithFallback
      src={`${WEBFILES_BASE}/${appLogoUri}`}
      fallback={`${WEBFILES_BASE}/default/${
        login ? 'logoLogin' : 'logoHeader'
      }.png`}
      ultimateFallback={defaultLogo}
      alt="logo"
      loading="lazy"
      {...otherProps}
    />
  );
};

export default AppLogo;
